import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import EnrollmentRequestPage from "@/pages/EnrollmentRequestPage";
import TeacherDashboard from "@/pages/TeacherDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ParentDashboard from "@/pages/ParentDashboard";
import ParentReenrollmentPage from "@/pages/ParentReenrollmentPage";

const ROLES_TEACHER = ["teacher"];
const ROLES_ADMIN = ["admin"];
const ROLES_PARENT = ["parent"];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/connexion" element={<LoginPage />} />
                <Route path="/demande-inscription" element={<EnrollmentRequestPage />} />
                <Route path="/enseignant" element={<ProtectedRoute roles={ROLES_TEACHER}><TeacherDashboard /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute roles={ROLES_ADMIN}><AdminDashboard /></ProtectedRoute>} />
                <Route path="/parent" element={<ProtectedRoute roles={ROLES_PARENT}><ParentDashboard /></ProtectedRoute>} />
                <Route path="/parent/reinscription" element={<ProtectedRoute roles={ROLES_PARENT}><ParentReenrollmentPage /></ProtectedRoute>} />
              </Routes>
            </Layout>
            <Toaster position="top-right" />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
